/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 大麦获取选座页token
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: number,
  showId: number,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.DaMaiSeatTokenDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/damai/token/${productId}/${showId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
